import { createSlice } from '@reduxjs/toolkit';

// Snackbar 상태 관리(전역 상태 초기값)
/**
 * Snackbar 상태 관리
 * - open: Snackbar 열림 여부
 * - message: Snackbar에 표시할 메시지
 * - type: Snackbar 유형 (success, error, info, warning)
 * - closeSnackbar: Snackbar 닫기 액션
 * - 사용 예시:
 *  dispatch(showSnackbar({ message: '저장되었습니다.', type: 'success' }));
 *  => 초기값으로 설정해 다음과 같이 사용 : dispatch(showSnackbar());
 *  => 다른 메시지나 유형을 설정하고 싶다면 아래와 같이 메시지와 타입을 전달하면 됩니다.
 *  dispatch(showSnackbar({ message: '오류 발생', type: 'error' }));
 */

const initialState = {
  open: false,
  message: '저장되었습니다.',
  type: 'success', // 'error' | 'info' | 'success' | 'warning'
};

const SnackbarSlice = createSlice({
  name: 'Snackbar',
  initialState,
  reducers: {
    showSnackbar: (state, action) => {
      const { message = '저장되었습니다.', type = 'success' } =
        action.payload || {};
      state.open = true;
      state.message = message;
      state.type = type;
    },
    closeSnackbar: (state) => {
      state.open = false;
    },
    newYnErrorSnackbar: (state, action) => {
      const {
        message = '데이터 입력중입니다. 저장 후 시도하세요.',
        type = 'warning',
      } = action.payload || {};
      state.open = true;
      state.message = message;
      state.type = type;
    },
  },
});

export const { showSnackbar, closeSnackbar, newYnErrorSnackbar } =
  SnackbarSlice.actions;
export default SnackbarSlice.reducer;
